import {
  Box,
  Checkbox,
  InputLabel,
  TextField,
  Typography,
  useTheme,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import RulesModal from "../RulesModal";
import CustomTabbar from "../../../../components/CustomTabBar";
import CustomInput from "../../../../components/CustomInput";
import CustomSelectOption, {
  Ioption,
} from "../../../../components/CustomSelectOption";
import OtpInput from "../OtpInput";
import { Link } from "react-router-dom";
import CustomButton from "../../../../components/CustomButton";
import CommentDotInActive from "../../../../../media/images/icons/commentDotInActive";
import ArrowLeftSVG from "../../../../../media/images/icons/arrow-left";
import { useFormik } from "formik";
import CustomInputLabel from "../../../../components/CustomInputLabel";

export default function DriverSignup() {
  const theme = useTheme();

  const [isvalidForm, setIsValidForm] = useState(false);
  const [otpState, setOtpState] = useState(false);

  const [rules, setRules] = useState(false);
  const [months, setMonths] = useState<Ioption[]>([]);

  const [userSignupTab, setuserSignupTab] = useState("burdenOwner");

  const mymonths = [
    "فروردین",
    "اردیبهشت",
    "خرداد",
    "تیر",
    "مرداد",
    "شهریور",
    "مهر",
    "آبان",
    "آذر",
    "دی",
    "بهمن",
    "اسفند",
  ];

  useEffect(() => {
    setMonths(
      mymonths.map((item, index) => ({ label: item, value: index + 1 }))
    );
  }, []);

  const formik = useFormik({
    initialValues: {
      dateOfBrith: {
        jy: 1300,
        jm: 8,
        jd: 26,
      },
    },
    onSubmit: (values) => {
      console.log(values);
    },
  });

  const handleDateOfBrith = (value: any, selectFor: string) => {
    switch (selectFor) {
      case "year":
        formik.setFieldValue("dateOfBrith", {
          ...formik.values.dateOfBrith,
          jy: value,
        });

        break;
      case "month":
        formik.setFieldValue("dateOfBrith", {
          ...formik.values.dateOfBrith,
          jm: value,
        });

        break;
      case "day":
        formik.setFieldValue("dateOfBrith", {
          ...formik.values.dateOfBrith,
          jd: value,
        });

        break;

      default:
        break;
    }
  };

  return (
    <Box
      sx={{
        // border: "1px solid green",
        backgroundColor: "background.default",

        justifySelf: "center",
        boxShadow: "0px 4px 15px 3px rgba(0,0,0,0.1)",
        paddingX: "10px",
        paddingY: "16px",
        borderRadius: "16px",
        marginX: "auto",
      }}
    >
      <RulesModal open={rules} handleClose={() => setRules(false)} />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          flex: "1",
        }}
      >
        <CustomTabbar
          color={{
            main: theme.palette.primary.main,
            light: theme.palette.primary.light,
          }}
          title={{
            title1: "ثبت نام صاحبان بار",
            title2: "ثبت نام رانندگان",
          }}
        />
        <Box
          sx={{
            flex: "1",
            overflow: "auto",
            px: 1,
            // maxHeight: {
            //   xs: "auto",
            //   sm: "400px",
            //   md: "300px",
            //   lg: "300px",
            //   xl: "500px",
            // }, // Limiting the height
          }}
        >
          <Box
            sx={{
              mt: "16px",
            }}
          >
            <CustomInputLabel required htmlFor="outlined-adornment-amount">
              {"کد ملی راننده"}
            </CustomInputLabel>

            <CustomInput placHolder="کدملی راننده را وارد کنید..." />
          </Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
          >
            <Box
              sx={{
                mt: "16px",
                flex: 1,
              }}
            >
              <CustomInputLabel required htmlFor="outlined-adornment-amount">
                {userSignupTab === "burdenOwner"
                  ? "نام راننده"
                  : "نام کاربری راننده"}{" "}
              </CustomInputLabel>{" "}
              <CustomInput placHolder="نام‌ راننده را وارد کنید..." />
            </Box>
            <Box
              sx={{
                mt: "16px",
                flex: 1,
              }}
            >
              <CustomInputLabel required htmlFor="outlined-adornment-amount">
                {userSignupTab === "burdenOwner"
                  ? "نام خانوادگی راننده"
                  : "نام کاربری راننده"}
              </CustomInputLabel>

              <CustomInput
                placHolderSize={12}
                placHolder="نام‌خانوادگی راننده را وارد کنید..."
              />
            </Box>
          </Box>
          <Box
            sx={{
              mt: "16px",
              flex: 1,
            }}
          >
            <CustomInputLabel required htmlFor="outlined-adornment-amount">
              {"شماره گواهینامه"}
            </CustomInputLabel>

            <CustomInput placHolder="شماره گواهینامه راننده را وارد کنید..." />
          </Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
          >
            <Box
              sx={{
                mt: "16px",
                flex: 1,
              }}
            >
              <InputLabel
                sx={{
                  color: "primary.main",
                  fontWeight: 600,
                  marginBottom: "8px",
                  fontSize: "14px",
                }}
                htmlFor="outlined-adornment-amount"
              >
                {"سال تولد:"}
              </InputLabel>
              <CustomSelectOption
                selectFor={"year"}
                handleChange={handleDateOfBrith}
                options={new Array(80).fill(1).map((item, index) => ({
                  label: 1300 + index,
                  value: 1300 + index,
                }))}
                value={formik.values.dateOfBrith.jy}
              />
            </Box>
            <Box
              sx={{
                mt: "16px",
                flex: 1,
              }}
            >
              <InputLabel
                sx={{
                  color: "primary.main",
                  fontWeight: 600,
                  marginBottom: "8px",
                  fontSize: "14px",
                }}
                htmlFor="outlined-adornment-amount"
              >
                {"ماه تولد:"}
              </InputLabel>

              <CustomSelectOption
                selectFor="month"
                handleChange={handleDateOfBrith}
                value={formik.values.dateOfBrith.jm}
                options={months}
              />
            </Box>
            <Box
              sx={{
                mt: "16px",
                flex: 1,
              }}
            >
              <InputLabel
                sx={{
                  color: "primary.main",
                  fontWeight: 600,
                  marginBottom: "8px",
                  fontSize: "14px",
                }}
                htmlFor="outlined-adornment-amount"
              >
                {"روز تولد:"}
              </InputLabel>

              <CustomSelectOption
                selectFor="day"
                handleChange={handleDateOfBrith}
                value={formik.values.dateOfBrith.jd}
                options={new Array(30).fill(1).map((item, index) => ({
                  label: index + 1,
                  value: index + 1,
                }))}
              />
            </Box>
          </Box>
          <Box
            sx={{
              mt: "16px",
              display: "flex",
              alignItems: "center",
              gap: "10px",
            }}
          >
            <InputLabel
              sx={{
                color: "primary.main",
                fontWeight: 600,
                marginBottom: "8px",
                fontSize: "14px",
              }}
              htmlFor="outlined-adornment-amount"
            >
              {"کد معرف(اختیاری):"}
            </InputLabel>

            <TextField
              size="small"
              placeholder="کد معرف را وارد کنید تا هردو امتیاز دریافت کنید"
              sx={{
                flex: "1",
                width: "100%",
                fontSize: "12px",
              }}
            />
          </Box>
          <Box
            sx={{
              mt: "16px",
              flex: 1,
            }}
          >
            <CustomInputLabel required htmlFor="outlined-adornment-amount">
              {"تلفن همراه راننده"}
            </CustomInputLabel>

            <CustomInput placHolder="تلفن همراه راننده را وارد کنید..." />
          </Box>
          {otpState && <OtpInput />}
        </Box>
      </Box>
      <Box
        sx={{
          backgroundColor: "background.default",
        }}
      >
        {otpState && (
          <Box
            sx={{
              display: "flex",
              alignItems: "start",
            }}
          >
            <Checkbox />
            <Typography
              sx={{
                fontSize: "13px",
                fontWeight: "600",
                marginTop: "10px",
              }}
            >
              من تایید می‌کنم که{" "}
              <Link
                onClick={() => setRules(true)}
                style={{
                  color: theme.palette.primary.main,
                }}
                to={"#"}
              >
                {"قوانین و مقررات"}
              </Link>{" "}
              را مطالعه کرده‌ام و شرایط بازارگاه کارن ترابرنت را می‌پذیرم.
            </Typography>
          </Box>
        )}
        <CustomButton
          disabled={isvalidForm}
          // loading={loading}
          // onClick={formik.handleSubmit}

          textColor={"background.default"}
          // borderColor="textColor.light"
          // type={!isvalidForm ? "outlined" : "contained"}
          flexDirection="row"
          title={
            !otpState ? "ارسال رمز یک‌بار مصرف به تلفن" : "تایید رمز و ثبت نام"
          }
          justifyContent="center"
          bgColor={isvalidForm ? "secondary.main" : "textColor.light"}
          width="100%"
          fSize="16px"
          fontWeight={500}
          px="10px"
          py="10px"
          borderRadius="10px"
          color="lightStatic.main"
          icon1={!otpState && <CommentDotInActive size={20} />}
          mt="16px"
        />
      </Box>
    </Box>
  );
}
